import { render } from "./project-list.vue?vue&type=template&id=ca719eb4&scoped=true&ts=true"
import script from "./project-list.vue?vue&type=script&lang=ts"
export * from "./project-list.vue?vue&type=script&lang=ts"

import "./project-list.vue?vue&type=style&index=0&id=ca719eb4&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca719eb4"]])

export default __exports__